var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "", "open-on-hover": "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                "div",
                _vm._g(
                  _vm._b(
                    {
                      staticStyle: { cursor: "pointer" },
                      attrs: { color: "primary", dark: "" },
                    },
                    "div",
                    attrs,
                    false
                  ),
                  on
                ),
                [
                  _c("flag", { attrs: { iso: _vm.$t("langcodeShort") } }),
                  _vm._v(" " + _vm._s(_vm.$t("langcodeShort")) + " "),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        "v-list",
        { staticStyle: { "min-width": "7rem" } },
        _vm._l(_vm.languages, function (language, index) {
          return _c(
            "v-list-item",
            {
              key: index,
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.changeLanguage(language)
                },
              },
            },
            [
              _c(
                "v-list-item-title",
                [
                  _c("flag", { attrs: { iso: language.flagCode } }),
                  _vm._v(" " + _vm._s(language.title) + " "),
                ],
                1
              ),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }